import {Component, Inject, ElementRef, QueryList, ViewChild, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';
import {IdexService} from 'app/idex.service';
import {Path} from 'app/shared/path';
import {FoldersComponent} from '../../../dms/folders/folders.component';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {Toast} from '../../../shared/toast/toast';
import {TranslateService} from '@ngx-translate/core';
import {Mimetype} from '../../../shared/mimetype';
import {GoogleDriveListComponent} from '../../../dms/google-drive-list/google-drive-list.component';
import { SocialLogin } from 'app/account/social-login';
import {DropBox} from '../../../dms/dropbox/dropbox.service';
import { EformService } from 'app/e-form/service/eform.service';

declare let $: any;
declare let ginkgosoft_domain: string;

@Component({
   selector: 'app-select-file-document',
   templateUrl: './select-file-document.component.html',
   styleUrls: ['./select-file-document.component.css'],
   animations: [
      trigger('state', [
         state('collapse', style({height: 0})),
         state('expand', style({height: '*'})),
         transition('collapse => expand', animate('400ms ease-in')),
         transition('expand => collapse', animate('400ms ease-out'))
      ])
   ]
})
export class SelectFileDocumentComponent implements OnInit {
   animationState = 'collapse';
   folders: any[];
   loading = false;
   loadingSearch = false;
   error: string;
   selectedItem: any;
   selected: boolean;
   business = this.service.user.business;
   path: string;
   public isSearch= false;
   public isSearchOneDrive= false;


   public isFolder= false;
   selectedItems: any[] = [];
   user: any;
   item: any;
   private tin: string;
   searchInput: any;
   searchResult: any;
   private pos = 50;
   private size = 50;
   private timer: any;
   hasMore = false;
   lessItem: boolean;
   private selectedItemPath: any;
   selectedIndexTab = 0;
   selectedIndexTabOld = 0;
   private drivePath: string;
   access_token: any;
   microsoft_domain: any;
   enableSearch: boolean = true;
   pageToken: any;

   googleList: any[] = [];

   oneDriveList: any[] = [];

   dropboxlist:any[] = [];
   isSelect: boolean;
   folderMimeType: string = 'application/vnd.google-apps.folder';
   shortcutMimeType: string = 'application/vnd.google-apps.shortcut';
   selectFileType;
   typeName;

   @ViewChild(GoogleDriveListComponent, { static: true }) GoogleDriveList: GoogleDriveListComponent;
   @ViewChild('tabgroup') tabs:QueryList<ElementRef>;

   constructor(private router: Router, private service: IdexService, public toast: Toast,private dropbox: DropBox,
               private translate: TranslateService,
               private dialogRef: MatDialogRef<SelectFileDocumentComponent>,
               @Inject(MAT_DIALOG_DATA) public data: any,
               private socialLogin:SocialLogin,
               private eFormService: EformService,
   ) {}

   ngOnInit(): void {
      switch (this.selectFileType) {
         case 'zDox' : {
            break;
         }
         case 'google drive' : {
            this.loading = true;
            try {

               this.drivePath = 'root';
               this.access_token = sessionStorage.getItem('access_token_google');
               if (this.access_token) {
                  this.showDocument();
               } else {
                  this.signInGoogle();
               }
            } catch (e) {
               if(e.status === 401){
                  this.signInGoogle();
               }else{
                  this.toast.error(e.message)
                  this.dialogRef.close();
               }
            }

            break;
         }
         case 'onedrive' : {
            this.loading = true;

            try {
               this.access_token = localStorage.getItem('access_token');
               if (this.access_token) {
                     this.showDocumentOneDrive()
               } else {
                  this.signinAndCheckCallBackOneDrive()
               }
            } catch (e) {
               if(e.status === 401){
                  this.signinAndCheckCallBackOneDrive()
               }else{
                  this.toast.error(e.message)
                  this.dialogRef.close();
               }
            }

            break;
         }
         case 'dropbox' : {
            this.loading = true;
            try {
               this.access_token = localStorage.getItem('access_token_dropbox');
               if (this.access_token) {
                  this.showDocumentDropBox();
               } else {
                  this.signinAndCheckCallBackDropBox();
               }
            } catch (e) {
               if(e.status === 401){
                  this.signinAndCheckCallBackDropBox();
               }else{
                  this.dialogRef.close();
               }
            }
         }
      }
    }

   signInGoogle(){
      this.loading = true;
      this.socialLogin.withGoogle().subscribe(result => {
         this.access_token = sessionStorage.getItem("access_token_google")
         this.showDocument();
      }, error => {
         this.data.toast.error(error);
         this.dialogRef.close();
      });
   }

   isExpanded(): boolean {
      return this.animationState === 'expand';
   }

   navigate(name: string, sub: FoldersComponent) {
      if (!sub.isExpanded()) {
         sub.toggle();
      }
      const url = this.tin ? Path.combine('/work', this.tin, encodeURIComponent(this.path),
         encodeURIComponent(name)) : Path.combine('/files', encodeURIComponent(this.path), encodeURIComponent(name));
      this.router.navigate([url]);
   }


   onSelectPath(agreed: any , search : boolean, uploadType: string) {
      if(!agreed.isFolder) {
         this.path = agreed.name;
         this.isFolder= true;
         if(search){
            agreed.uploadType = uploadType;
            this.selectedItems.push(agreed);
            this.selectDoc();//เลือกจากช่อง Search แล้้วปิด Dialog
         }
      } else{
         this.isFolder= false;
      }
   }

   onSearch(isSearch: any) {
      this.isSearch = isSearch;
      this.pos =  50;

      // clear selected items
      $('.selectedPath').removeClass('selectedPath');
      if(this.selectedItems){
         for (let i = 0; i < this.selectedItems.length; i++) {
            this.selectedItems[i].selected = false
         }
      }

      this.selectedItems = [];
      this.changeSearchTree(this.searchInput);
   }

   setSearchInput(searchInput: any){
      this.searchInput = searchInput;
   }

   getIcon(item: any): string {
      return Mimetype.getIcon(item);
   }

   changeSearchTree(searchInput: any) {
      this.searchResult = null
      this.hasMore = false;
      if (this.isSearch && this.searchInput.length > 2) {
         this.timer = setTimeout(() => {
            this.timer = null;

            switch (this.selectFileType) {
               case 'zDox' : {
                  this.service.search(encodeURIComponent(this.searchInput), 0, this.size, false, false, true)
                  .subscribe(
                     data => {
                        this.hasMore = data.hasMore;
                        this.searchResult = data.items;
                        this.loading = false;
                        if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                           this.lessItem = true;
                           this.loadMore('');
                        }
                     });
                  break;
               }
               case 'onedrive' : {
                  this.service.oneDriveSearchQuery(this.access_token,searchInput,0,this.size)
                     .subscribe(
                        res => {
                           const hitsContainers = res.value[0].hitsContainers[0];

                           if(hitsContainers.hits && hitsContainers.total > 0){
                              this.hasMore = hitsContainers.moreResultsAvailable;
                              this.searchResult = hitsContainers.hits;
                              if (this.searchResult.length < 20 && this.hasMore ) {
                                 this.lessItem = true;
                                 this.loadMore('');
                              }
                           }else{
                              this.searchResult=[];
                           }
                        });
                  break;
               }
               case 'google drive' : {
                  this.pageToken = '';
                  this.service.getGoogleDriveSearch(encodeURIComponent(this.searchInput), this.access_token, this.pos, this.pageToken)
                  .subscribe(
                     res => {
                        const data = JSON.parse(res);
                        this.hasMore = data.nextPageToken ? true : false;
                        this.pageToken = data.nextPageToken;
                        this.searchResult = data.files;
                        this.loading = false;
                        if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                           this.lessItem = true;
                           this.loadMore('');
                        }
                     });
                  break;
               }
               case 'dropbox' : {
                  this.service.getSearchDropbox(this.access_token, searchInput , this.pos)
                     .subscribe(res => {
                        this.hasMore = res.hasMore;
                        this.searchResult= res.entries.filter((file) => file.folder !== true).sort(this.sortName);
                        this.loading = false;
                        if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                           this.lessItem = true;
                           this.loadMore('');
                        }
                     });
                  break;
               }
            }

         }, 300);
      } else {
         this.searchResult = [];
      }
   }

   loadMore(e) {
      if ((this.lessItem && this.hasMore)|| (e.target.scrollHeight  <= e.target.scrollTop + e.target.offsetHeight && this.hasMore)) {
         if (this.timer) {
            clearTimeout(this.timer);
         }
         const q = this.searchInput;
         if (q.length === 0) {
            return;
         }
         this.timer = setTimeout(() => {
            this.timer = null;
            switch (this.selectFileType) {
               case 'zDox' : {
                  this.service.search(encodeURIComponent(q), this.pos, this.size, false, false, true)
                  .subscribe(
                     data => {
                        if (this.timer == null) {
                           this.hasMore = data.hasMore;
                           this.searchResult.push.apply(this.searchResult, data.items);
                           this.pos += this.size;
                           if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                              this.lessItem = true;
                              this.loadMore('');
                           } else {
                              this.lessItem = false;
                           }
                        }
                     });
                  break;
               }
               case 'onedrive' : {
                  this.service.oneDriveSearchQuery(this.access_token,q, this.size,this.pos)
                  .subscribe(
                     res => {
                        if (this.timer == null) {
                           const hitsContainers = res.value[0].hitsContainers[0];
                           if(hitsContainers.hits && hitsContainers.total > 0){
                              this.hasMore = hitsContainers.moreResultsAvailable;
                              this.searchResult.push.apply(this.searchResult, hitsContainers.hits);
                              this.pos += this.size;

                              if (this.searchResult.length < 20 && this.hasMore) {
                                 this.lessItem = true;
                                 this.loadMore('');
                              }else {
                                 this.lessItem = false;
                              }
                           }
                        }
                     });
                  break;
               }
               case 'google drive' : {
                  this.service.getGoogleDriveSearch(encodeURIComponent(q), this.access_token, this.pos, this.pageToken)
                  .subscribe(
                     res => {
                        if (this.timer == null) {
                           const data = JSON.parse(res);
                           this.hasMore = data.nextPageToken ? true : false;
                           this.pageToken = data.nextPageToken;
                           this.searchResult.push.apply(this.searchResult, data.files);
                           this.pos += this.size;
                           if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                              this.lessItem = true;
                              this.loadMore('');
                           } else {
                              this.lessItem = false;
                           }
                        }
                     });
                  break;
               }
               case 'dropbox' : {
                  this.service.getSearchDropbox(this.access_token, q , this.pos)
                     .subscribe(res => {
                        if (this.timer == null) {
                           this.hasMore = res.hasMore;
                           this.searchResult= res.entries.filter((file) => file.folder !== true).sort(this.sortName);
                           if (this.searchResult.length < 20 && this.hasMore) { // เช๋คกรณีตัวเลือกน่อยกว่า 8 แล้วมี hasmore โหลดเพิ่ม
                              this.lessItem = true;
                              this.loadMore('');
                           } else {
                              this.lessItem = false;
                           }
                        }
                     }, err => {
                        this.toast.error(err.message)
                     });
                  break;
               }
            }

         }, 300);
      }
   }

   expand(folders: any, isFolder:boolean) {
      if (!folders.isExpanded() && isFolder) {
         folders.toggle();
      }
   }

   handleToastError(key) {
      this.translate.get(key).subscribe((msg) => {
         this.toast.error(msg);
      });
   }

   selectDoc(){
      if(!this.selectedItems){
         this.handleToastError('newTask.errorSelectFile');
      }else {
         let isDup = false;
         for (let i of this.data){
            for (let select of this.selectedItems){
               if(select.id === i.docId || ((select.name === i.originalName || select.name === i.docName) && (select.name.endsWith('.zdox') && i.docName.endsWith('.zdox')))) {
                  if(this.selectedItems.length > 1){
                     const index = this.selectedItems.map(e => e.id).indexOf(select.id);
                     this.selectedItems.splice(index, 1);
                  }else{
                     isDup = true;
                     this.handleToastError('newTask.errorDuplicateSelect');
                     this.selectedItems.splice(select);
                     break;
                  }
               }
            }
         }
         if (this.eFormService.validateZdoxOneFile(this.selectedItems, this.data)) {
            isDup = true;
            this.handleToastError('uploadDoc.errorOneForm');
         }
         if(!isDup) {
            this.dialogRef.close(true);
         }
      }
   }

   closeDialog() {
      this.dialogRef.close(false);
   }

   selectFiles(event: any, item: any, uploadType: 'zDox' | 'google drive' | 'onedrive'| 'dropbox'){
      switch (uploadType) {
         case 'zDox': {
            if(!item.isFolder) {
               event.preventDefault();
               if ((item.permissions.write || item.isFolder) && ((!item.startFlow && item.statusDocument === '') || item.statusDocument === 'Completed')
                  && this.getValidateExtension(item.mimeType)) {
                  item.selected = !item.selected;
                  const index = this.selectedItems.indexOf(item);
                  if (item.selected) {
                     if (index === -1) {
                        item.uploadType = uploadType;
                        this.selectedItems.push(item);
                     }
                  } else {
                     if (index !== -1) {
                        this.selectedItems.splice(index, 1);
                     }
                  }
               }
               break;
            }
         }
         case 'google drive': {
            if(this.getValidateExtension(item.mimeType)) {
               event.preventDefault();
               item.selected = !item.selected;
               const index = this.selectedItems.indexOf(item);
               if (item.selected) {
                  if (index === -1) {
                     item.uploadType = uploadType;
                     this.selectedItems.push(item);
                  }
               } else {
                  if (index !== -1) {
                     this.selectedItems.splice(index, 1);
                  }
               }
            }
            break;
         }

         case 'onedrive': {
            if(item.file){
               if (this.getValidateExtension(item.file.mimeType)) {
                  event.preventDefault();
                  item.selected = !item.selected;
                  const index = this.selectedItems.indexOf(item);
                  if (item.selected) {
                     if (index === -1) {
                        item.uploadType = uploadType;
                        this.selectedItems.push(item);
                     }
                  } else {
                     if (index !== -1) {
                        this.selectedItems.splice(index, 1);
                     }
                  }
               }
            }

            break;
         }

         case 'dropbox': {
            if(item.mimeType !== 'application/octet-stream' || item.name.endsWith('.zdox')){
               if (this.getValidateExtension(item.mimeType, 'dropbox')) {
                  event.preventDefault();
                  item.selected = !item.selected;
                  const index = this.selectedItems.indexOf(item);
                  if (item.selected) {
                     if (index === -1) {
                        item.uploadType = uploadType;
                        this.selectedItems.push(item);
                     }
                  } else {
                     if (index !== -1) {
                        this.selectedItems.splice(index, 1);
                     }
                  }
               }
            }
            break;
         }
      }
   }

   showDocument() {
      this.service.getGoogleDriveList(this.drivePath, this.access_token, 0, null)
         .subscribe(res => {
            const data = JSON.parse(res);
            this.googleList = data.files;
            this.loading = false;
         }, e => {
            if (e.code === 401 || e.status === 401) {
               this.signInGoogle()
            } else {
               this.dialogRef.close();
            }
         });
   }

   signinAndCheckCallBackOneDrive(){
      this.loading = true;
      this.socialLogin.withMicrosoft().subscribe(result => {
         this.access_token = localStorage.getItem("access_token")
         if(this.access_token){
            this.showDocumentOneDrive();
         }else{
            this.dialogRef.close();
         }
      }, error => {
         this.data.toast.error(error);
         this.dialogRef.close();
      });
   }


   showDocumentOneDrive(){
      this.checkSearchOneDrive();
      this.service.onedriveList(this.access_token).subscribe(
         res => {
            this.oneDriveList = res.value
            this.loading = false;
         },error => {
            this.handleErrorOnedrive(error);
         })
   }

   signinAndCheckCallBackDropBox(){
      this.loading = true;
      this.socialLogin.withDropBox().subscribe(result => {
         this.access_token = localStorage.getItem("access_token_dropbox");
         this.showDocumentDropBox();
      }, error => {
         this.data.toast.error(error);
         this.dialogRef.close();
      });
   }

   showDocumentDropBox(){
      this.service.getListFileDropbox(this.access_token,'').subscribe(
         res => {
            this.dropboxlist = res.entries.sort(this.sortName);
            this.loading = false;
         },error => {
            this.dialogRef.close();
            this.signinAndCheckCallBackDropBox()
         })
   }

   sortName(a, b) {
      if (a.name.toLowerCase() < b.name.toLowerCase()) {
         return -1;
      }
      if (a.name.toLowerCase() > b.name.toLowerCase()) {
         return 1;
      }
      return 0;
   }

   getIconGoogleDrive(item: any): string {
      return Mimetype.getIconGoogleDrive(item);
   }

   getIconOneDrive(item: any): string {
      return Mimetype.getIconOneDrive(item);
   }

   oneDriveIgnoreFileType(item: any): boolean {
      if (!item.file) {
         return false
      } else {
         return !Mimetype.validateExtension(item.file.mimeType, this.typeName);
      }
   }

   oneDriveIsFolder(item: any): boolean {
      return Boolean(!item.file)
   }

   dropBoxIsFolder(item: any): boolean {
      const type = Mimetype.getIconDropbox(item);
      return type === 'assets/icons/folder.svg';
   }

   getIconDropbox(item: any): string {
      return Mimetype.getIconDropbox(item);
   }
   dropBoxIgnoreFileType(item: any): boolean {
      if (item.mimeType === 'application/octet-stream') {
         return false
      } else {
         return !Mimetype.validateExtension(item.mimeType, this.typeName);
      }
   }


   select(name: any, sub: any , isFolder:boolean) {
      if(this.isSelect) {
         $('.selectedPath').removeClass('selectedPath');
         $('#move' + name.id).addClass('selectedPath');
         if (!sub.isExpanded() && isFolder) {
            sub.toggle();
         }
         if (this.selectedItem === sub) {
            return;
         }
         if (this.selectedItem) {
            this.selectedItem.selected = false;
         }
         this.selectedItem = sub;
         sub.selected = true;
      }
   }

   getValidateExtension(item:any, platform?: string):boolean{
      if (item) {
         return Mimetype.validateExtension(item, this.typeName, platform);
      } else {
         return true;
      }
   }

   handleErrorOnedrive(error): void {
      if (error.status === 401 && error.error) {
        if (error.error.innerError) {
          this.handleUnauthorizedError();
        } else {
          this.handleErrorAndCloseDialog(error.message);
        }
      } else {
        this.handleErrorAndCloseDialog(error.message);
      }
    }

    private handleUnauthorizedError(): void {
      this.loading = true;
      this.clearSelectedItems();
      this.signinAndCheckCallBackOneDrive();
    }

    private handleErrorAndCloseDialog(errorMessage: string): void {
      setTimeout(() => {
        this.toast.error(errorMessage);
      }, 0);
      this.dialogRef.close();
    }


   clearSelectedItems(){
      $('.selectedPath').removeClass('selectedPath');
      this.selectedItems = [];
   }

   replaceIdOneDrive(id): String {
      return id.replace( "!","_");
   }

   replaceIdDropBox(id): string {
      return id.replaceAll("/","_").replaceAll(" ","_");
   }

   checkSearchOneDrive(){
         const domain = localStorage.getItem('microsoft_domain');
         if (domain) {
             this.enableSearch = domain.includes(ginkgosoft_domain);
         }else{
            this.enableSearch = false;
         }
   }

}
